"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupHotProbabilityByOutcomeId = groupHotProbabilityByOutcomeId;
const betweb_openapi_axios_1 = require("betweb-openapi-axios");
const groupProbabilitiesByOutcomeTypeId_1 = require("../probabilities/groupProbabilitiesByOutcomeTypeId");
const probabilityHasValueParameter_1 = require("../probabilities/probabilityHasValueParameter");
const findBestPair_1 = require("../probabilities/findBestPair");
function groupHotProbabilityByOutcomeId(event, hotProbsMarkets, selectors = {}) {
    var _a, _b, _c, _d;
    const probabilities = {};
    if (((_a = event.probabilities) === null || _a === void 0 ? void 0 : _a.markets) === undefined) {
        return probabilities;
    }
    for (const market of (_b = event.probabilities) === null || _b === void 0 ? void 0 : _b.markets) {
        const hotProbsMarket = hotProbsMarkets[market.marketId];
        if (hotProbsMarket === undefined) {
            continue;
        }
        if ([betweb_openapi_axios_1.MarketType.Handicap, betweb_openapi_axios_1.MarketType.Total].includes(hotProbsMarket.market.type)) {
            const [leftOutcomeId, rightOutcomeId] = hotProbsMarket.orderedOutcomeTypeIds;
            if (hotProbsMarket.orderedOutcomeTypeIds.length !== 2) {
                continue;
            }
            if (leftOutcomeId === undefined || rightOutcomeId === undefined) {
                continue;
            }
            const group = (0, groupProbabilitiesByOutcomeTypeId_1.groupProbabilitiesByOutcomeTypeId)(market.probabilities);
            const leftProbs = (_c = group[leftOutcomeId]) !== null && _c !== void 0 ? _c : [];
            const rightProbs = (_d = group[rightOutcomeId]) !== null && _d !== void 0 ? _d : [];
            if (leftProbs.length === 0 && rightProbs.length === 0) {
                continue;
            }
            let hasSelectedPair = false;
            if (selectors[market.marketId] !== undefined) {
                const { leftValue, rightValue } = selectors[market.marketId];
                const leftProb = leftProbs.find((0, probabilityHasValueParameter_1.probabilityHasValueParameter)(leftValue));
                const rightProb = rightProbs.find((0, probabilityHasValueParameter_1.probabilityHasValueParameter)(rightValue));
                if (leftProb) {
                    probabilities[leftOutcomeId] = leftProb;
                    hasSelectedPair = true;
                }
                if (rightProb) {
                    probabilities[rightOutcomeId] = rightProb;
                    hasSelectedPair = true;
                }
            }
            if (hasSelectedPair) {
                continue;
            }
            let leftProb = leftProbs.find((p) => p.central);
            let rightProb = rightProbs.find((p) => p.central);
            if (leftProb === undefined && rightProb === undefined) {
                const [left, right] = (0, findBestPair_1.findBestPair)(leftProbs, rightProbs, hotProbsMarket.hotProbabilityMarketType);
                if (left) {
                    leftProb = left;
                }
                if (right) {
                    rightProb = right;
                }
            }
            if (leftProb === undefined && rightProb === undefined) {
                continue;
            }
            if (leftProb) {
                probabilities[leftOutcomeId] = leftProb;
            }
            if (rightProb) {
                probabilities[rightOutcomeId] = rightProb;
            }
        }
        else {
            market.probabilities.forEach((prob) => {
                probabilities[prob.outcomeTypeId] = prob;
            });
        }
    }
    return probabilities;
}
//# sourceMappingURL=groupHotProbabilityByOutcomeId.js.map